import {
  ImageIcon,
  InsertDriveFileIcon,
  PictureAsPdfIcon,
} from '@billda/design-system';

export function getFileIcon(contentType: string, size: number) {
  if (contentType === 'application/pdf') {
    return (
      <PictureAsPdfIcon
        className="text-content-error"
        size={size}
        aria-hidden="true"
      />
    );
  }
  if (contentType.startsWith('image/')) {
    return (
      <ImageIcon
        className="text-content-accent"
        size={size}
        aria-hidden="true"
      />
    );
  }
  return (
    <InsertDriveFileIcon
      size={size}
      className="text-content-secondary"
      aria-hidden="true"
    />
  );
}
